import { Button, Card, Col, Row } from "react-bootstrap"
import { useTranslation } from "react-i18next"
import TitleCounter from "components/others/TitleCounter";
import { useEffect, useState } from "react";
import vconst from "utils/helpers/structs/vconst";
import * as apiObject from "api/apiObject4Team";
import { useToast } from "context/ToastContext";
import ESpinner from "components/others/Spinner";
import { useGlobal } from "context/GlobalContext";
import { useLocation } from "react-router-dom";
import ObjectItem from "./ObjectItem";
import { OffClientInfo } from 'modules/client';
import SpinnerBlock from "components/others/SpinnerBlock";
import OffObjectCard from "../OffObjectCard";
import EToolTip from "components/others/EToolTip";
import SolarIcon from 'components/icons/SolarIcon';

const ObjectList4Team = () => {
 
    const { t } = useTranslation(['Objects']);
    const { g } = useGlobal();
    const { showToast } = useToast();
    const [ objectsList, setObjectsList ] = useState(null);
    const [ showSpinner, setShowSpinner ] = useState(false);
    const [ isLoading, setInLoading ] = useState(false);
    const [ clientInfoId, setClientInfoId ] = useState(null);
    const [ count, setCount ] = useState(null);
    const [ firstLoad, setFirstLoad ] = useState(true);
    const [ showObject, setShowObject ] = useState(false);
    const location = useLocation(); 

    const fetchObjects = async (isLoadingEnable=true) => { 
        const listData = {
            page    : 1,
            onPage  : 99999,
            status  : [vconst.objectPanding, vconst.objectInWork]
        } 

        if (isLoadingEnable) setInLoading(true);
        const resObjects = await apiObject.getList(listData);
        if (!resObjects) {
            setInLoading(false);
            return showToast(t('common:messError'), 'danger');
        }
        setObjectsList(resObjects.objects);
        setCount(resObjects?.paginator?.countRows);
        setFirstLoad(false);
        setInLoading(false);
    }



    useEffect(()=>{
        fetchObjects();
    },[g.target]);

 
    return (<>

        <OffObjectCard
            showObject={showObject}
            setShowObject={setShowObject}/>

        <OffClientInfo
            clientId={clientInfoId}
            setClientId={setClientInfoId}/>

        <Row> 
        <Col className="col-sticky" sm={12}>
            <div className="w-100 d-sm-flex pt-1 justify-content-between align-items-start" style={{minHeight:51}}>
                <div>
                    <h4 className="p-0 m-0 mb-0 me-2 text-break">{t("titleList4Team")} </h4> 
                    <TitleCounter
                        count={count}/> 
                </div>
                <div className="mt-2 mt-sm-0">
                    <div className="page-toolbar-actions">
                        <EToolTip title={t('common:toolRefreshList')}>
                            <span className="d-inline-block">
                                <Button
                                    className="fs-14 px-2 toolbar-icon-btn"
                                    size="sm"
                                    disabled={isLoading}
                                    onClick={(e) => {
                                        e.currentTarget.blur();
                                        void fetchObjects();
                                    }}
                                >
                                    <SolarIcon name="arrow-clockwise" className="fs-14 p-0" />
                                </Button>
                            </span>
                        </EToolTip>
                    </div>
                </div>
            </div>
        </Col>
        <Col sm={12}>            
                 
            {objectsList
                ? (<Row>
                    <SpinnerBlock show={isLoading} onlyBlur={true}/>
                    {objectsList?.map(vobject=>{
                        return (
                            <ObjectItem key={`object ${vobject.ID}`} 
                                setClientInfoId={setClientInfoId}
                                vobject={vobject}
                                fetchObjects={fetchObjects}
                                setShowObject={setShowObject}/>)
                    })}
                </Row>)
                        
                : (<ESpinner/>)}
                 
        </Col>
        </Row> 
    </>)
} 

export default ObjectList4Team; 